import { render, staticRenderFns } from "./VideosGallery.vue?vue&type=template&id=51205212&scoped=true"
import script from "./VideosGallery.vue?vue&type=script&lang=js"
export * from "./VideosGallery.vue?vue&type=script&lang=js"
import style0 from "./VideosGallery.vue?vue&type=style&index=0&id=51205212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51205212",
  null
  
)

export default component.exports